
define('text!modules/privacy/states/privacy-admin/template.html',[],function () { return '<div ui-view=360-feedback></div><div ui-view=feedback-sharing></div>';});

